import { render } from "./GroupDetailsModal.vue?vue&type=template&id=7efe8e89&scoped=true"
import script from "./GroupDetailsModal.vue?vue&type=script&lang=js"
export * from "./GroupDetailsModal.vue?vue&type=script&lang=js"

import "./GroupDetailsModal.vue?vue&type=style&index=0&id=7efe8e89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efe8e89"]])

export default __exports__